export default "__VITE_ASSET__f9UxpkJL__"